<template>
  <div
    id="quiz-item"
    class="contanier-quiz-item"
    @click="toggleActive"
    :class="active ? 'bg' : 'bg-hover'"
    @mouseenter="onHover(true)"
    @mouseleave="onHover(false)"
  >
    <div
      v-if="active || isHover"
      :class="active ? 'icon-reorder' : 'icon-reorder-hover'"
      class="icon-reorder handle"
    >
      <icon-drag-drop />
    </div>
    <div
      class="card-quiz-inner mb-0"
      :class="active ? 'card-inner' : 'card-inner-hover'"
    >
      <div v-if="!active">
        <b-row class="w-100 m-0 card-p-30px">
          <b-col cols="7" class="p-0" v-if="nameNoHtml">
            <div class="editor font-medium-4" v-safe-html="formQuestion.name"></div>
          </b-col>
          <b-col cols="7" v-if="!nameNoHtml">
            <div
              data-placeholder="ระบุ"
              class="text-no-data font-medium-4"
            ></div>
          </b-col>
        </b-row>
        <b-row class="m-0 card-p-30px">
          <b-col class="p-0" v-if="descNoHtml">
            <div class="editor font-medium-4" v-safe-html="formQuestion.desc"></div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="card-p-30px" v-if="formQuestion.image.url">
              <div class="image-display-wrp">
                <div
                  class="image-display"
                  :style="{
                    'background-image': `url(${formQuestion.image.url})`,
                  }"
                ></div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="group-choice-wrp" v-if="formQuestion.format">
              <draggable
                :list="formQuestion.dataChoice"
                @start="dragging = true"
                @end="dragging = false"
                item-key="name"
              >
                <div
                  class="group-choice list-group-item item mt-1 font-medium-4"
                  v-for="element in formQuestion.dataChoice"
                  :key="element.seqChoice"
                >
                  <div class="w-100">
                    <div
                      class="d-flex align-item-center justify-content-between w-100 card-p-30px"
                      :class="element.isCorrect ? 'choice-correct' : ''"
                    >
                      <div
                        class="d-flex w-80"
                        :class="
                          formQuestion.format == 3 ? null : 'display-radio'
                        "
                      >
                        <div v-if="formQuestion.format" class="mt-7px">
                          <b-form-radio
                            v-model="element.isCorrect"
                            disabled
                            class="custom-radio-group mr-3"
                            value="true"
                          />
                        </div>
                        <div class="w-100" v-if="formQuestion.format == 1">
                          <div class="input-choice">
                            {{ element.choiceName }}
                          </div>
                          <div
                            v-if="!element.choiceName"
                            data-placeholder="ระบุ"
                            class="text-no-data font-medium-4"
                          ></div>
                        </div>
                        <div class="w-100" v-if="formQuestion.format == 2">
                          <div class="d-flex">
                            <div
                              class="image-upolad-wrp"
                              v-if="element.imageChoice.url"
                            >
                              <div
                                class="image-upload-inner"
                                :style="{
                                  'background-image': `url(${element.imageChoice.url})`,
                                }"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div class="w-100" v-if="formQuestion.format == 3">
                          <div class="input-choice">
                            {{ element.choiceName }}
                          </div>
                          <div>
                            <div
                              class="image-upolad-wrp"
                              v-if="element.imageChoice.url"
                            >
                              <div
                                class="image-upload-inner"
                                :style="{
                                  'background-image': `url(${element.imageChoice.url})`,
                                }"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="element.isCorrect">
                        <div
                          class="w-100 d-flex justify-content-center align-item-center"
                        >
                          <span><icon-check class="icon-check mr-1" /></span>
                          <span class="text-correct">ข้อที่ถูกต้อง</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="active">
        <b-row class="w-100 m-0 d-flex justify-content-between card-p-30px">
          <b-col cols md="7" class="p-0 mt-1">
            <div
              v-if="!activeQuestion && !nameNoHtml"
              data-placeholder="Question*"
              class="text-no-data font-medium-4"
              @click="toggledInputFocus(activeHover.QUIZ_NAME)"
            ></div>
            <div
              class="editor font-medium-4"
              v-if="!activeQuestion && nameNoHtml"
              v-safe-html="formQuestion.name"
              @click="toggledInputFocus(activeHover.QUIZ_NAME)"
            ></div>
            <div id="toolbar-editor" v-if="activeQuestion">
              <quill-editor
                toolbar="#my-toolbar"
                ref="quizNameQuill"
                class="custom-quill-editor flex-stretch h-100"
                :options="customQuillOption"
                v-model="formQuestion.name"
                @ready="onFocusInput('quizNameQuill')"
                required
              >
              </quill-editor>
              <div id="my-toolbar">
                <custom-toolbar />
              </div>
            </div>
          </b-col>
          <b-col cols md="5" class="p-0">
            <div class="d-flex justify-content-end w-100">
              <b-row>
                <b-col class="d-flex p-0">
                  <b-form-group>
                    <div id="quiz-select-type" class="p-relative">
                      <single-choice-svg
                        v-if="formQuestion.type == 1"
                        class="icon-container"
                      />
                      <v-select
                        class="v-select-filter bg-dropdown mr-2 p-0"
                        v-model="formQuestion.type"
                        :options="optionQuestion.typeChoiceOption"
                        :reduce="(option) => option.value"
                        :searchable="false"
                        placeholder="Status"
                        :clearable="false"
                      >
                        <template slot="option" slot-scope="option">
                          <component
                            :is="option.icon"
                            class="mr-1 action-dropdown-svg icon-container"
                          />
                          <div class="pl-1">{{ option.label }}</div>
                        </template></v-select
                      >
                    </div>
                  </b-form-group>
                  <v-select
                    class="v-select-filter bg-dropdown p-0"
                    placeholder="Status"
                    v-model="formQuestion.format"
                    :searchable="false"
                    :options="optionQuestion.formatChoiceOption"
                    :reduce="(option) => option.value"
                    :clearable="false"
                    @input="onChangeFormat"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row class="m-0 card-p-30px">
          <b-col class="p-0">
            <div
              v-if="!activeDesc && !descNoHtml"
              data-placeholder="Desciption"
              class="text-no-data font-medium-4"
              @click="toggledInputFocus(activeHover.QUIZ_DESC)"
            ></div>
            <div
              class="editor font-medium-4"
              v-if="!activeDesc && descNoHtml"
              v-safe-html="formQuestion.desc"
              @click="toggledInputFocus(activeHover.QUIZ_DESC)"
            ></div>
            <div id="toolbar-editor" v-if="activeDesc">
              <quill-editor
                toolbar="#my-toolbar"
                ref="quizDescQuill"
                class="custom-quill-editor flex-stretch h-100"
                :options="customQuillOption"
                v-model="formQuestion.desc"
                @ready="onFocusInput('quizDescQuill')"
              >
              </quill-editor>
              <div id="my-toolbar">
                <custom-toolbar />
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="card-p-30px">
          <b-col>
            <div v-if="!showUploadImage.isShow">
              <div class="btn-add-image-wrp mt-2" @click="onShowUploadImage">
                <div class="btn-add-image mr-2">
                  <icon-plus class="icon-plus" />
                </div>
                <div class="title-btn-add-image">Add Image</div>
              </div>
            </div>
            <div v-else class="mt-1">
              <div class="font-medium-4">
                <span class="text-black mr-2">Image</span>
                <span class="desc-title">(Format JPG, JPEG, PNG Max 2 Mb)</span>
              </div>
              <image-upload
                removable
                :imageUrl="formQuestion.image.url"
                @onUpload="onUploadImage($event, formQuestion)"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="group-choice-wrp" v-if="formQuestion.format">
              <draggable
                :list="formQuestion.dataChoice"
                @start="dragging = true"
                @end="dragging = false"
                item-key="name"
                handle=".handle"
                :animation="100"
                @change="onChange(formQuestion.dataChoice)"
              >
                <div
                  class="group-choice list-group-item item mt-2"
                  v-for="element in formQuestion.dataChoice"
                  :key="element.seqChoice"
                >
                  <div class="w-100">
                    <div
                      class="d-flex justify-content-between w-100 card-p-30px"
                      :class="[
                        { 'choice-correct': element.isCorrect },
                        { 'align-item-center': formQuestion.format != 3 },
                      ]"
                    >
                      <div
                        class="d-flex w-100"
                        :class="
                          formQuestion.format == 3 ? null : 'display-radio'
                        "
                      >
                        <div
                          class="handle mr-1"
                          :class="[
                            { 'mb-8px': formQuestion.format == 2 },
                            { 'mt-2px': formQuestion.format == 3 },
                          ]"
                        >
                          <icon-drag-drop class="icon-reorder-choice" />
                        </div>
                        <div
                          v-if="formQuestion.type == 1"
                          :class="formQuestion.format == 2 ? null : 'mt-7px'"
                        >
                          <b-form-radio
                            v-model="element.answer"
                            name="mode-radios"
                            disabled
                          />
                        </div>
                        <div class="w-100" v-if="formQuestion.format == 1">
                          <b-form-input
                            id="input-choice-radio"
                            v-model="element.choiceName"
                            class="input-choice w-80"
                            placeholder="ระบุ"
                          ></b-form-input>
                        </div>
                        <div class="w-100" v-if="formQuestion.format == 2">
                          <div>
                            <image-upload
                              class="w-100"
                              isChoice
                              :imageUrl="element.imageChoice.url"
                              @onUpload="onUploadImageChoice($event, element)"
                            />
                          </div>
                        </div>
                        <div class="w-100" v-if="formQuestion.format == 3">
                          <b-form-input
                            id="input-choice-radio"
                            v-model="element.choiceName"
                            class="input-choice w-80 mb-8px"
                          ></b-form-input>
                          <div>
                            <image-upload
                              class="w-100"
                              isChoice
                              :imageUrl="element.imageChoice.url"
                              @onUpload="onUploadImageChoice($event, element)"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mr-3rem" v-if="formQuestion.format">
                        <b-form-checkbox
                          v-model="element.isCorrect"
                          value="true"
                          class="mr-4 mt-4px"
                          @change="setCorrect(element)"
                        >
                        </b-form-checkbox>
                        <icon-trash
                          class="icon-trash-question"
                          v-if="formQuestion.dataChoice.length > 1"
                          @click.native="onRemoveChoice(element)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </b-col>
        </b-row>
        <b-row class="card-p-30px">
          <b-col cols="12">
            <div v-if="formQuestion.format">
              <div
                class="add-choice font-medium-5"
                @click="onAddChoice(formQuestion)"
              >
                Add Answer
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="mt-1">
              <div class="font-medium-4 mb-8px">
                กรุณาระบุเหตุผลข้อที่ถูกต้อง
              </div>
              <b-form-textarea
                v-model="formQuestion.reason"
                placeholder="ระบุ"
                rows="2"
                no-resize
              ></b-form-textarea>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="active" class="card-p-30px">
          <b-col>
            <div class="d-flex justify-content-end mt-2">
              <!-- <icon-duplicate
                class="icon-duplicate-question mr-4"
                @click.native="onDuplicate(formQuestion)"
              /> -->
              <img
                class="icon-duplicate-question mr-4"
                @click="onDuplicate(formQuestion)"
                :src="IconCopy"
              />
              <icon-trash
                class="icon-trash-question ml-4"
                @click.native="onRemoveQuestion(formQuestion)"
              />
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import IconDragDrop from "@/@core/components/svg/common/IconDragDrop.vue";
import IconTrash from "@/@core/components/svg/common/IconTrash.vue";
import IconDuplicate from "@/@core/components/svg/common/IconDuplicate.vue";
import SingleChoiceSvg from "@/@core/components/svg/question-modal/SingleChoice.vue";
import QuestionImageUploader from "@/@core/components/image-uploader/QuestionImageUploader.vue";
import IconPlus from "@/@core/components/svg/common/IconPlus.vue";
import ImageUpload from "./ImageUpload.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Quill from "quill";
import CustomToolbar from "./CustomToolbarEditor.vue";
import IconCheck from "@/@core/components/svg/common/IconCheck.vue";
import useQuizItem from "../hooks/useQuizItem";
import IconCopy from "@/assets/images/icons/IconCopy.png";

export default {
  components: {
    draggable,
    IconDragDrop,
    IconTrash,
    IconDuplicate,
    SingleChoiceSvg,
    QuestionImageUploader,
    IconPlus,
    ImageUpload,
    CustomToolbar,
    IconCheck,
  },
  props: {
    formQuestion: {
      type: [Object, Array],
      default: {},
    },
    active: { type: Boolean, default: false },
    optionQuestion: { type: Object },
  },
  setup(props) {
    const {
      toggleActive,
      handleInput,
      toggleActiveChioce,
      onShowUploadImage,
      showUploadImage,
      onUploadImage,
      onAddChoice,
      onUploadImageChoice,
      onRemoveChoice,
      onRemoveQuestion,
      customQuillOption,
      activeQuestion,
      activeDesc,
      toggledInputFocus,
      onFocusInput,
      setCorrect,
      onDuplicate,
      onChange,
      activeHover,
      nameNoHtml,
      descNoHtml,
      onChangeFormat,
      onHover,
      isHover,
    } = useQuizItem(props);

    return {
      toggleActive,
      handleInput,
      toggleActiveChioce,
      onShowUploadImage,
      showUploadImage,
      onUploadImage,
      onAddChoice,
      onUploadImageChoice,
      onRemoveChoice,
      onRemoveQuestion,
      customQuillOption,
      activeQuestion,
      activeDesc,
      toggledInputFocus,
      onFocusInput,
      setCorrect,
      onDuplicate,
      onChange,
      activeHover,
      nameNoHtml,
      descNoHtml,
      onChangeFormat,
      onHover,
      isHover,
      IconCopy,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/quiz/quiz-item.css";
@import "~@/assets/css/pages/quiz/toolbar-editor.css";
</style>
